import { render, staticRenderFns } from "./TransferConversationModal.vue?vue&type=template&id=597bb061&scoped=true&"
import script from "./TransferConversationModal.vue?vue&type=script&lang=js&"
export * from "./TransferConversationModal.vue?vue&type=script&lang=js&"
import style0 from "./TransferConversationModal.vue?vue&type=style&index=0&id=597bb061&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "597bb061",
  null
  
)

export default component.exports